import script from "./SectionTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionTitle.vue?vue&type=script&setup=true&lang=js"

import "./SectionTitle.vue?vue&type=style&index=0&id=b5d8e754&lang=scss"

const __exports__ = script;

export default __exports__